<div class="form-modal">
    <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
        aria-label="Close course feedback form">
        <img src="./assets/img/icons-svg/close-icon.svg">
    </a>
    <div class="form-wrapper-80">
        <div class="title-wrapper">
            <h2 translate>theory.courses.feedback.title</h2>
        </div>
        <p translate>
            theory.courses.feedback.description
        </p>
    </div>


    <div class="form-wrapper">

        <p translate>theory.courses.feedback.question</p>

        <div class="app-c-form-group">
            <select class="app-c-form-control" [(ngModel)]="helpful" aria-required="true">
                <option value="">-- Select --</option>
                <option value="5" translate>theory.courses.feedback.options.5</option>
                <option value="4" translate>theory.courses.feedback.options.4</option>
                <option value="3" translate>theory.courses.feedback.options.3</option>
                <option value="2" translate>theory.courses.feedback.options.2</option>
                <option value="1" translate>theory.courses.feedback.options.1</option>
            </select>
        </div>

    </div>

    <div class="clearfix"></div>
    <div class="fixed-footer">
        <a tabindex="0" aria-label="Save" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()"
            (keypress)="doSave()" translate>theory.courses.feedback.save</a>
    </div>
</div>